import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDemoMode } from '../../hooks/useDemoMode';
import { isDemoFeatureAllowed } from '../../config/featureFlags';

/** Gates /demo/* routes — requires Demo Workspace feature flag + active demo session. */
export const RequireDemoSandbox: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDemoMode } = useDemoMode();
  const location = useLocation();

  if (!isDemoFeatureAllowed()) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!isDemoMode) {
    return <Navigate to="/demo" replace state={{ from: location.pathname, needsEnable: true }} />;
  }
  return <>{children}</>;
};

export const DemoSandboxRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RequireDemoSandbox>{children}</RequireDemoSandbox>
);

export default RequireDemoSandbox;
